import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Loader, { LoaderType } from "../component/common-component/Loader";
import { useDispatch } from "react-redux";
import { CompanyDetailsByCode } from "../services/ReduxTookit/Slice/ProjectTermRedux";

const TermsAndConditionInAll = (props) => {
  const [subscriberData, setSubscriberData] = useState(null);
  const [termsAndPrivacyLoader, setTermsAndPrivacyLoader] = useState(false);
  const [PrivacyData, setPrivacyData] = useState([]);
  const [PrivacyLoader, setPrivacyLoader] = useState(false);
  const dispatch = useDispatch();

  const getPrivacyData = async () => {
    setTermsAndPrivacyLoader(true);
    dispatch(CompanyDetailsByCode())
      .then((response) => {
        if (response?.payload?.isValidate) {
          setPrivacyData(response?.payload?.data?.data);
        }
        if (!response?.payload?.isValidate) {
          setPrivacyData([]);
        }
      })
      .finally(() => {
        setTermsAndPrivacyLoader(false);
      });
  };

  useEffect(() => {
    getPrivacyData();
  }, []);

  // useEffect(() => {
  //   if (props?.subscriberId) {
  //     getSubscriberDetailByPrimaryKey();
  //   }
  // }, [props?.subscriberId]);

  return (
    <div>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
        backdrop="static"
        // className="terms-condition-privacy-policy-modal"
        className="terms-height"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {props.type === "Terms" ? "Terms and Condition" : "Privacy Policy"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="mb-0">
          {termsAndPrivacyLoader ? (
            <Loader type={LoaderType.Line} count={9} />
          ) : props.type === "Terms" ? (
            <p
              dangerouslySetInnerHTML={{
                __html: PrivacyData?.devclitermandconditions
                  ? PrivacyData?.devclitermandconditions
                  : "No Data Found",
              }}
            />
          ) : (
            //{/* Confirmed from Ashish */}
            <p
              dangerouslySetInnerHTML={{
                __html: PrivacyData?.qdldevprivacypolicy
                  ? PrivacyData?.qdldevprivacypolicy
                  : "No Data Found",
              }}
            />
          )}
          {/* {termsAndPrivacyLoader ? (
            <> </>
          ) : (
            <div className="text-end">
              <button
                className="blue-btn w-auto mt-3"
                type="reset"
                onClick={props.onHide}
              >
                Close
              </button>
            </div>
          )} */}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default TermsAndConditionInAll;
